function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0dasdassafasd)",
  filter: "url(#filter0_dasfdasfasdf)"
}, /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.3,
  cx: 231.622,
  cy: 256.625,
  rx: 158.819,
  ry: 185.574,
  transform: "rotate(-16.2625 231.622 256.625)",
  fill: "url(#paint0_linearssssasfasd)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M377.48 249.053C402.488 334.783 387.641 503.699 314.745 524.963C241.85 546.227 138.511 411.788 113.502 326.058C88.494 240.328 127.314 153.592 200.209 132.328C273.105 111.063 352.471 163.323 377.48 249.053Z",
  fill: "url(#paint1_linearsdasdssafasdfsa)"
}), /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.3,
  cx: 260.455,
  cy: 334.776,
  rx: 117.76,
  ry: 155,
  transform: "rotate(-16.2625 260.455 334.776)",
  fill: "url(#dfdasfsadfas)"
}), /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.4,
  cx: 282.087,
  cy: 403.023,
  rx: 111.329,
  ry: 168.592,
  transform: "rotate(-16.2625 282.087 403.023)",
  fill: "url(#asdfasdfasfasdfsafsa)"
}), /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.5,
  cx: 292.669,
  cy: 419.839,
  rx: 91.2754,
  ry: 143,
  transform: "rotate(-16.2625 292.669 419.839)",
  fill: "url(#asdfasfasfasdfdsfdsf)"
}), /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.7,
  cx: 282.04,
  cy: 370.453,
  rx: 49.0397,
  ry: 57,
  transform: "rotate(-16.2625 282.04 370.453)",
  fill: "url(#dfddssdds)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dasfdasfasdf",
  x: 0,
  y: 0,
  width: 400,
  height: 400,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 25
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.882465 0 0 0 0 0.918168 0 0 0 0 0.958333 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linearssssasfasd",
  x1: 76.444,
  y1: 217.462,
  x2: 268.285,
  y2: 112.524,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A768C5",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.634549,
  stopColor: "#E492AB",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3B2B8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linearsdasdssafasdfsa",
  x1: 119.282,
  y1: 265.39,
  x2: 275.576,
  y2: 237.361,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A768C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.634549,
  stopColor: "#E492AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3B2B8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "dfdasfsadfas",
  x1: 151.025,
  y1: 284.735,
  x2: 310.811,
  y2: 311.236,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A768C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.634549,
  stopColor: "#E492AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3B2B8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "asdfasdfasfasdfsafsa",
  x1: 193.523,
  y1: 324.491,
  x2: 338.5,
  y2: 358.827,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A768C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.634549,
  stopColor: "#E492AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3B2B8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "asdfasfasfasdfdsfdsf",
  x1: 220.826,
  y1: 349.582,
  x2: 333.724,
  y2: 379.836,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A768C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.634549,
  stopColor: "#E492AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3B2B8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "dfddssdds",
  x1: 243.564,
  y1: 344.621,
  x2: 324.708,
  y2: 356.035,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A768C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.634549,
  stopColor: "#E492AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3B2B8"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0dasdassafasd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 300,
  height: 300,
  fill: "white",
  transform: "translate(50 42)"
})));

function SvgIntro1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro1);
export default __webpack_public_path__ + "static/media/intro1.73acc823.svg";
export { ForwardRef as ReactComponent };